/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type TripInfoAlertCardStopFragment = {
  __typename?: 'Stop'
  id: string
  names: Partial<Record<'de' | 'en', string>>
  address: {
    __typename?: 'StopAddress'
    street: string | null
    houseNumber: string | null
  }
  routingLocation: {
    __typename?: 'Location'
    latitude: number
    longitude: number
  }
}

export const TripInfoAlertCardStopFragmentDoc = gql`
    fragment TripInfoAlertCardStop on Stop {
  id
  address {
    street
    houseNumber
  }
  names
  routingLocation {
    latitude
    longitude
  }
}
    `
